import { c as _c } from "react/compiler-runtime";
import { useMobileSize } from "@repo/common/hooks/use-mobile-size";
import { Logo } from "./logo";
import { ErrorBoundary } from "@repo/ui/components/ui/error-boundary";
export function LayoutAuth(t0) {
  const $ = _c(14);
  const {
    primary,
    secondary
  } = t0;
  const isMobile = useMobileSize();
  const t1 = isMobile ? "linear-gradient(184deg, #FFF 0.77%, #FFFDFB 6.77%, #FCF9F5 11.06%, #F9F4EF 30.35%, #F4EBE4 81.93%)" : "linear-gradient(184deg, #FFF 3.77%, #FFFDFB 12.77%, #FCF9F5 26.06%, #F9F4EF 48.35%, #F4EBE4 92.93%)";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      background: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="fixed top-0 left-0 h-1 bg-brand w-full z-20" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex justify-center lg:block lg:absolute lg:left-[calc((100%-529px)/2)] lg:top-16 py-8 lg:pt-0 z-20"><Logo /></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== primary) {
    t5 = <div className="w-full lg:w-1/2 lg:min-h-0 relative flex flex-col lg:overflow-y-auto lg:bg-transparent px-4 md:px-8 lg:px-8">{t4}<div className="flex flex-col gap-12 md:gap-4 lg:flex lg:items-center lg:justify-center py-2 lg:py-16 lg:pt-[6.5rem] lg:my-auto shrink-0"><div className="w-full max-w-[529px] mx-auto"><ErrorBoundary>{primary}</ErrorBoundary></div></div></div>;
    $[4] = primary;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== secondary) {
    t6 = <div className="w-full lg:w-1/2 flex-shrink-0 pb-20 pt-8 md:pt-0 lg:pb-0 lg:min-h-0"><ErrorBoundary>{secondary}</ErrorBoundary></div>;
    $[6] = secondary;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <div className="flex flex-col pt-0 md:pt-0 flex-1 min-h-0 lg:absolute lg:inset-0 lg:top-[4px] lg:flex lg:justify-center lg:overflow-hidden"><div className="flex flex-col lg:flex-row w-full flex-1 min-h-0 lg:overflow-hidden max-w-[1400px] mx-auto">{t5}{t6}</div></div>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t2 || $[12] !== t7) {
    t8 = <div className="relative w-full min-h-screen flex flex-col bg-surface md:bg-transparent" style={t2}>{t3}{t7}</div>;
    $[11] = t2;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}